<template>
    <div class="course-record-page">
        <!-- 1、顶部菜单栏 -->
        <div class="course-title-bar dsp-flex">
            <div class="bg1"></div><div class="bg2"></div>
            <div class="title-side title-yellow">
                <span class="title-back discuss-title-back" @click="clickBack">
                    <i class="iconfont icon-xiangzuo"></i>
                </span>
            </div>
            <div class="title-middle">
                <span>学习记录</span>
            </div>
        </div>
        <!-- 2、学习记录列表 -->
        <div class="course-record-list">
            <course-record-item v-for="rData in courseRecordList" :key="'course-r-'+rData.id" :itemData="rData"></course-record-item>
        </div>
    </div>
</template>

<script>
import CourseRecordItem from '../../components/course/CourseRecordItem.vue'
import { MIX } from '../../modules/utils';
export default {
    name: 'CourseRecord',
    components: { CourseRecordItem },
    computed: {
        courseRecordList() {
            return this.$store.state.course.courseRecordList;
        }
    },
    data() {
        return {
        }
    },
    mounted: function() {
        setTimeout(() => {
            this.$store.dispatch('course/initCourseRecordList');
            MIX.trackPageViewed('LearnRecordPage');
        }, 20);
    },
    methods: {
        clickBack() {
            this.$store.dispatch('course/resetCourseRecordData');
            let from = this.$store.state.course.courseListPageFrom;
            this.$router.replace('/courselist/'+from);
        },
    }
}
</script>
